import { IS_NO_IP_ONLY_HTTPS } from 'constants/constants';
import { required } from 'utils/errorsTextHelper';
import * as yup from 'yup';

const urlValidationTest = {
  name: 'valid-url',
  message: 'Must be a valid URL, starting with https://, and not an IP address',
  test: (value: string | undefined) => !value || IS_NO_IP_ONLY_HTTPS(value)
};

export const projectInfoSchema = yup.object().shape({
  companyName: yup.string().required(required('Store project name')),
  domain: yup
    .string()
    .required(required('Domain'))
    .matches(
      /^(?!https?:\/\/)(?!.*\/$)[a-zA-Z0-9.-]+$/,
      "Please enter a valid domain name, without 'http://' or 'https://' prefixes or suffixes"
    )
});

export const portalInfoSchema = yup.object().shape({
  portalName: yup.string().required(required('Name')),
  domain: yup
    .string()
    .required(required('Domain'))
    .matches(
      /^(?!https?:\/\/)(?!.*\/$)[a-zA-Z0-9.-]+$/,
      "Please enter a valid domain name, without 'http://' or 'https://' prefixes or suffixes"
    )
});

export const authPlayerSchema = yup.object().shape({
  playersAuthWebhook: yup.string().test(urlValidationTest)
});

export const grantAwardSchema = yup.object().shape({
  ordersReportingApiUrl: yup.string().test(urlValidationTest),
  awardingV2ApiUrl: yup.string().test(urlValidationTest)
});

export const personalizeSchema = yup.object().shape({
  playerInfoSyncUrl: yup.string().test(urlValidationTest)
});

export const eventsWebhookSchema = yup.object().shape({
  eventsWebhookUrl: yup.string().test(urlValidationTest),
  eventsV2WebhookUrl: yup.string().test(urlValidationTest)
});

export const otpSchema = yup.object().shape({
  otpOn: yup.boolean(),
  otpGenerateDeeplinkUrl: yup.string(),
  otpTextModel: yup.string()
});

export const appsFlyerSchema = yup.object().shape({
  appsFlyerIntegrationOn: yup.boolean(),
  appsFlyerS2SToken: yup.string().when('appsFlyerIntegrationOn', {
    is: true,
    then: yup.string().required('AppsFlyer S2S token is required'),
    otherwise: yup.string().notRequired()
  }),
  appsFlyerApplicationID: yup.string().when('appsFlyerIntegrationOn', {
    is: true,
    then: yup.string().required('Application ID is required'),
    otherwise: yup.string().notRequired()
  })
});

